

















































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { CourseListener as ICourseListener } from "@/api/models/course-listener";
import { UserDocumentInfo as IUserDocumentInfo } from "@/api/models/user-document-info";
import api, { courseApi } from "@/getinfo-api";
import { Registration as IRegistration } from "@/api-v2/course/models";

type IListener = ICourseListener & { version?: string };

@Component
export default class ExpulsionOrderFormItemUsers extends Vue {
  @Prop() listener!: IListener;
  userPositionData!: IUserDocumentInfo;
  registration!: IRegistration;

  data() {
    return {
      userPositionData: undefined,
      registration: undefined
    };
  }

  getStatus(listener: ICourseListener) {
    let status: string = "";
    if (listener.status === "success")
      status = this.$tc(this.$translate.Completed);
    if (listener.status === "learning")
      status = this.$tc(this.$translate.NotComplete);
    if (listener.status === "not_success")
      status = this.$tc(this.$translate.CompletedUnsuccessfully);
    return status;
  }

  getPositionData() {
    api.UsersApi.getDocumentInfo(this.listener.user.id).then(
      (res: { data: IUserDocumentInfo }) => {
        this.userPositionData = res.data;
      }
    );
  }

  get screenWidth() {
    return window.innerWidth;
  }

  created() {
    this.getPositionData();
    if (this.listener.version === "v2") {
      courseApi.CourseRegistration.getCourseRegistration(this.listener.id).then(
        ({ data }) => {
          this.registration = data;
        }
      );
    }
  }
}
